import { AZURE_SPEECH_FAMILY } from '@UI/Pages/Administration/AiEngines/azureSpeechValues';

/** The minimal shape this constraint reads. */
type ChunkBoundShape = {
	readonly family: string | null;
};

/**
 * Empty means "the server's own value"; otherwise a whole number of seconds from 60 to 1200. Inactive
 * for the Azure Speech family, whose own bound is checked by `isAzureSpeechChunkMaxSecondsValid`.
 */
function isChunkMaxSecondsValid<T extends ChunkBoundShape>(value: string, formData: T): boolean {
	if (value === '' || formData.family === AZURE_SPEECH_FAMILY) {
		return true;
	}

	const seconds = Number(value);

	return Number.isInteger(seconds) && seconds >= 60 && seconds <= 1200;
}

export default isChunkMaxSecondsValid;
